import React from 'react';
import { IMAGES, SITE } from '../mock';
import ServicePage from '../components/ServicePage';
import SEO, { serviceSchema } from '../components/SEO';

export default function Immobilien() {
  return (
    <>
      <SEO
        path="/immobilien"
        title="Immobilien als Kapitalanlage – ohne Eigenkapital starten"
        description="Strukturierte Sparpläne für Anlageimmobilien in der Schweiz. Passives Einkommen, langfristige Wertsteigerung, steuerliche Vorteile – ohne klassisches Eigenkapital."
        schema={serviceSchema({ name: 'Immobilien als Kapitalanlage', description: 'Beratung und Vermittlung strukturierter Sparpläne für Anlageimmobilien.', url: '/immobilien' })}
      />
      <ServicePage
      excludeId="immobilien"
      kicker="Immobilien"
      title="Immobilien als"
      titleAccent="Kapitalanlage"
      hero={IMAGES.immobilien}
      lead="Ein strukturierter Sparplan eröffnet Dir die Möglichkeit, ohne Eigenkapitaleinsatz Immobilien als Kapitalanlage zu erwerben. Profitiere von Wertsteigerung und monatlichen Mieteinnahmen."
      bullets={[
        'Ohne Eigenkapitaleinsatz starten',
        'Monatliche Mieteinnahmen als passives Einkommen',
        'Langfristige Wertsteigerung der Immobilie',
        'Flexible Sparpläne nach deinen Möglichkeiten',
      ]}
      ctaPrimary={{ label: 'Beratungsgespräch sichern', href: '/kontakt', external: false }}
      body={[
        'Darüber hinaus bietet eine strukturierte Anlagestrategie Flexibilität und Kontrolle über die finanziellen Entscheidungen. Du kannst Dein Sparziel, die monatliche Einzahlung und die Auswahl der Anlageprodukte entsprechend Deinen individuellen Bedürfnissen und Möglichkeiten anpassen.',
        'Dies ermöglicht es Dir, Deinen finanziellen Fortschritt zu verfolgen und gegebenenfalls Anpassungen vorzunehmen, um Deine Ziele zu erreichen.',
        'Insgesamt eröffnet das Konzept Dir die Möglichkeit, <span class="text-[#e8d5a8]">langfristig Vermögen</span> aufzubauen und den Schritt in die Immobilienwelt zu wagen – selbst wenn Du über begrenztes Eigenkapital verfügst. Mit kluger Planung und langfristigem Ansatz erreichst du nicht nur den Traum vom Eigenheim, sondern auch nachhaltigen finanziellen Erfolg.',
      ]}
      />
    </>
  );
}
